import { Space } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAtomValue } from "jotai/utils";
import breadcrumbsAtom from "../../data/atoms/breadcrumbs";
import { faChevronLeft, faHome } from '@fortawesome/free-solid-svg-icons';
import Link from "../link";

import './index.css';

function Breadcrumb({ style, theme }) {
  const breadcrumbs = useAtomValue(breadcrumbsAtom);

  return (
    <Space className="bccampus-breadcrumb" split={<FontAwesomeIcon icon={faChevronLeft} />} style={style}>
      <span></span>
      <Link href="/" icon={faHome}>Home</Link>
      {
        breadcrumbs.length > 1 &&
        breadcrumbs.slice(0, -1).map(crumb =>
          < Link key={crumb.level} href={crumb.to}>
            {crumb.label}
          </Link>
        )
      }
    </Space >
  );
}

export default Breadcrumb;

